import React from 'react';

import { type AvailableProductsResponse, type ProviderResults } from '../../types';
import { type DataProvider } from './create-data-provider';
import { createAppSwitcherBffAvailableProductsProvider } from './app-switcher-bff-available-products-provider';
import type { WithCached } from '../utils/with-cached';

type RealProvider = DataProvider<AvailableProductsResponse>;
const {
	fetchMethod: fetchAppSwitcherBffAvailableProducts,
	ProviderComponent: DefaultBffDataProviderComponent,
} = createAppSwitcherBffAvailableProductsProvider() as RealProvider;

interface Props {
	children: (availableProducts: ProviderResults['availableProducts']) => React.ReactNode;
	cloudId?: string;
	product?: string;
}

export const AvailableProductsProvider = ({
	cloudId,
	product,
	children,
}: Props): React.JSX.Element => (
	<DefaultBffDataProviderComponent cloudId={cloudId} product={product}>
		{children}
	</DefaultBffDataProviderComponent>
);

export const prefetchAvailableProducts: WithCached<
	(param: object) => Promise<AvailableProductsResponse>
> = fetchAppSwitcherBffAvailableProducts;
export const resetAvailableProducts = (): void => fetchAppSwitcherBffAvailableProducts.reset();
